import styled from 'styled-components';
import { variant } from 'styled-system';
import { BaseIcon } from '../../../../../../../CommonComponents/OPL/Icon/Icon';
import { ColorProps } from '../../../../../../../theme/styledProps';

export type UploadFileVariant = 'uploading' | 'completed' | 'error' | 'cancelled';

interface ProgressIconProps {
  variant: UploadFileVariant;
}

export const ProgressIcon = styled(BaseIcon)<ProgressIconProps>(
  ({ theme }) => ({
    borderRadius: 8,
    cursor: 'pointer',

    '&[data-focus-visible-added]:focus': {
      boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}`,
      zIndex: 1,
    },
  }),

  variant<ColorProps, UploadFileVariant>({
    prop: 'variant',
    variants: {
      uploading: { color: 'neutral.500' },
      completed: { color: 'success.500' },
      error: { color: 'error.500' },
      cancelled: { color: 'neutral.500' },
    },
  }),
);
